<aux-extendable-options-dropdown
  class="attributes-dropdown"
  [ngClass]="{
    'show-placeholder': formControl.value === null,
  }"
  [items]="mapActivitiesModalService.invoiceItemOptions()"
  [resetValueOnEscapePress]="true"
  [initialSearchTerm]="initialSearchTerm"
  [dropdownControl]="formControl"
  [placeholder]="'Select or add invoice item'"
  [onChangedReturnOption]="true"
  (clickOut)="stopEditing()"
  (confirm)="stopEditing()"
  (addOption)="onAddOption($event)"
  (changed)="onChange($event)"
></aux-extendable-options-dropdown>
